import Vue from 'vue';
import { createHelpers } from 'vuex-map-fields';
import { ROUTE_API_SAVE_CARE_REQUEST, ROUTE_API_GET_CARE_REQUEST } from '@/constants/apiRoutes';

import {
  APPLICATION_REQUEST,
  APPLICATION_SAVE,
  APPLICATION_UPDATE,
  TOGGLE_EDITHCARE_POPUP,
} from '../actions/application';

const { getApplicationField, updateApplicationField } = createHelpers({
  getterType: 'getApplicationField',
  mutationType: 'updateApplicationField',
});

const obj = {
  status: null,
  appliedAt: null,
  careLevel: null,
};

const applications = [
  'erstantrag',
  'hoeherstufung',
  'pflegehilfsmittel',
  'hausnotruf',
  'wohnumfeldverbesserungen',
  'entlastungsbetrag',
  'pflegegeld',
  'pflegesachleistungen',
  'kombinationsleistung',
  'verhinderungspflege',
  'kurzzeitpflege',
  'tagesundnachtpflege',
];

const defaultState = {};
applications.map((a) => {
  defaultState[a] = obj;
});

const state = {
  applications: {
    ...defaultState,
  },
  neverUsed: true,
  applicationLoaded: false,
  openEdithCarePopup: false,
};

const getters = {
  getApplicationField,
};

const mutations = {
  updateApplicationField,

  [APPLICATION_SAVE]: (state, data) => {
    const { care_level: careLevel, applied_at: appliedAt, status, type } = data;

    state.applications[type] = {
      status,
      careLevel,
      appliedAt,
    };
  },
  [APPLICATION_UPDATE]: (state, data) => {
    state = Object.assign(state, data);
  },

  [TOGGLE_EDITHCARE_POPUP]: (state) => {
    state.openEdithCarePopup = !state.openEdithCarePopup;
  },
};

const actions = {
  [APPLICATION_REQUEST]: ({ rootState, commit }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(ROUTE_API_GET_CARE_REQUEST, { uuid: rootState.health.healthUuid })
        .then((response) => {
          const { careRequest } = response.data;
          careRequest.map((cr) => commit(APPLICATION_SAVE, cr));
          commit(APPLICATION_UPDATE, {
            neverUsed: careRequest.length === 0,
            applicationLoaded: true,
          });
          resolve();
        })
        .catch(reject);
    });
  },

  [APPLICATION_SAVE]: ({ dispatch, rootState }, { careRequest }) => {
    return new Promise((resolve, reject) => {
      Vue.axios
        .post(ROUTE_API_SAVE_CARE_REQUEST, {
          careRequest: {
            ...careRequest,
            personInNeedOfCareUuid: rootState.health.healthUuid,
          },
        })
        .then(() => {
          dispatch(APPLICATION_REQUEST).then(resolve).catch(reject);
        })
        .catch(reject);
    });
  },

  [TOGGLE_EDITHCARE_POPUP]: ({ commit }) => {
    commit(TOGGLE_EDITHCARE_POPUP);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
